<mat-progress-bar [style.visibility]="loading ? 'visible' : 'hidden'"
  mode="indeterminate">
</mat-progress-bar>
<form [formGroup]="form"
  (submit)="onSubmit()">
  <mat-form-field class="full-width">
    <input matInput
      autofocus
      class="full-width"
      formControlName="email"
      placeholder="Email">

    <mat-error *ngIf="!form.pristine && email.hasError('required')">
      Email is <strong>required</strong>
    </mat-error>
    <mat-error *ngIf="!form.pristine && email.hasError('maxlength')">
      Email is too <strong>long</strong>
    </mat-error>

    <mat-error *ngIf="!form.pristine && email.hasError('minlength')">
      Email is too <strong>short</strong>
    </mat-error>
  </mat-form-field>

  <button mat-flat-button
    [disabled]="form.disabled">Send Reset Email</button>
  <mat-error *ngIf="error">
    Could not send reset email.
  </mat-error>
</form>